import useRetrieveReturnDetailsCollectionSessionQuery from 'src/return/api/useRetrieveReturnDetailsCollectionSessionQuery';
import type {ReturnDetailsCollectionSessionCredentials} from 'src/return/state/useReturnDetailsCollectionContext';

type RetrieveReturnDetailsCollectionSessionCredentials = Pick<
  ReturnDetailsCollectionSessionCredentials,
  'clientSecret' | 'sessionId'
>;

export const useRetrieveReturnDetailsCollectionSession = (
  options: RetrieveReturnDetailsCollectionSessionCredentials,
) => {
  const result = useRetrieveReturnDetailsCollectionSessionQuery({
    component: 'useRetrieveReturnDetailsCollectionSession',
    variables: {
      input: {
        client_secret: options.clientSecret,
        return_details_collection_session: options.sessionId,
      },
    },
  });

  const data =
    result.data
      ?.v1CryptoInternalReturnDetailsCollectionSessionReturnDetailsCollectionSession;

  return {
    ...result,
    data,
  };
};
